// extracted by mini-css-extract-plugin
export default {"list":"PreviousAdded_list__qJdq9"};